import { render, staticRenderFns } from "./TimeToReset.vue?vue&type=template&id=6d0c6062&scoped=true&"
import script from "./TimeToReset.vue?vue&type=script&lang=js&"
export * from "./TimeToReset.vue?vue&type=script&lang=js&"
import style0 from "./TimeToReset.vue?vue&type=style&index=0&id=6d0c6062&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c6062",
  null
  
)

export default component.exports